import React, { useState } from 'react'

export default function LogoInput({logoUrl, onFileLoad}) {
  const [dragging, setDragging] = useState(false)
  const imgUrl = logoUrl && logoUrl.includes('data:') ? logoUrl : logoUrl + '?' + Math.random()

  const fileLoaded = (files) => {
    if (files && files[0]) onFileLoad(files[0])
  }

  const handleDrag = function(e) {
    e.preventDefault()
    e.stopPropagation()
    if (e.type === 'dragenter' || e.type === 'dragover') return setDragging(true)
    if (e.type === 'dragleave') return setDragging(false)
  }

  const handleDrop = function(e) {
    e.preventDefault()
    e.stopPropagation()
    setDragging(false)
    fileLoaded(e.dataTransfer.files)
  }

  return <div className='partner-image-form'>
    <input 
      type='file'
      accept='image/png'
      id='partner-image-input'
      onChange={(e) => fileLoaded(e.target.files)}
    />
    <label 
      id='partner-image-label'
      className={dragging ? 'active' : '' }
      htmlFor='partner-image-input'
      onDragEnter={handleDrag}
      onDragOver={handleDrag}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
    >
      <img src='/images/leagues/path.svg' />
      <span className='upload-button'>Upload a file</span>
      <span>PNG up to 10MB</span>
      <span><b>or drag and drop</b></span>
    </label>
    { logoUrl &&
      <div className='logo-preview'>
        <img alt='Icon' src={imgUrl} />
      </div>
    }
  </div>
}
